var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showWebtoonModal,
          expression: "showWebtoonModal",
        },
      ],
    },
    [
      _c("div", { staticClass: "webtoon_modal" }, [
        _c("div", { staticClass: "overlay" }),
        _c("div", { staticClass: "webtoon_modal_position" }, [
          _c("div", { staticClass: "modal-card" }, [
            _c(
              "div",
              {
                staticClass: "webtoon_modal_layout",
                staticStyle: {
                  padding: "0 !important",
                  "border-radius": "5px",
                  overflow: "hidden",
                },
              },
              [
                _vm.second
                  ? _c(
                      "div",
                      {
                        staticClass: "webtoon_modal_content second",
                        staticStyle: { padding: "0 !important" },
                      },
                      [
                        _c(
                          "Flicking",
                          {
                            attrs: {
                              options: { circular: false },
                              plugins: _vm.plugins,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "viewport",
                                  fn: function () {
                                    return [
                                      _c("span", {
                                        staticClass:
                                          "flicking-arrow-prev is-circle",
                                      }),
                                      _c("span", {
                                        staticClass:
                                          "flicking-arrow-next is-circle",
                                      }),
                                      _c("div", {
                                        staticClass: "flicking-pagination",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              859150525
                            ),
                          },
                          _vm._l(_vm.second, function (item, i) {
                            return _c("img", {
                              key: i,
                              staticClass: "w-100",
                              staticStyle: { "pointer-events": "none" },
                              attrs: { src: item },
                            })
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm.second
              ? _c("div", { staticClass: "webtoon_modal_footer" }, [
                  _c(
                    "span",
                    {
                      staticClass: "no_more_modal",
                      on: { click: _vm.noMoreWebtoon },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            this.$router.app._route.name === "Main"
                              ? "30일 동안 보지 않기"
                              : " "
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "no_more_modal just_close",
                      on: {
                        click: function ($event) {
                          return _vm.$store.commit("toggleWebtoonModal", {
                            state: false,
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("modal.close")) +
                          "\n          "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }